import React from "react";

export default function BackdropFilter({ description, videoUrl, fetchingModuleInfo = false }) {
    console.log("BACKDROP: ", fetchingModuleInfo);
    return (
        <div className="d-flex flex-column align-items-center justify-content-center" 
             style={{ height: '100vh', width: '100%', left: '0', top: '0', zIndex: '1', position: 'fixed', backdropFilter: 'blur(5px)' }}>
            <div className="card shadow-lg text-white" 
                 style={{ minHeight: '300px', minWidth: '300px', background: '#3699ff' }}>
                <div className="card-body d-flex flex-column justify-content-center" style={{ minHeight: '200px' }}>
                    {fetchingModuleInfo && (
                        <div className="h5 text-center">
                            <div className="spinner-border text-light" role="status">
                            </div>
                        </div>
                    )}
                    {!fetchingModuleInfo && !description !="" && (
                        <div className="h5 text-center"
                            dangerouslySetInnerHTML={{
                                __html: description
                            }}>
                        </div>
                    )}
                    {!fetchingModuleInfo && videoUrl !== "" && (
                        <video src={videoUrl} autoPlay controls style={{ width: '700px', maxHeight: '700px', objectFit: 'contain' }} />
                    )}
                    {!fetchingModuleInfo && description === "" && videoUrl === "" && (
                        <div className="h5 text-center">
                            <p>
                                This feature requires a higher subscription. <br />
                                Your current plan does not include access to this. <br />
                                Upgrade your subscription to unlock this powerful <br />
                                capability and enhance your workflow. <br />
                            </p>
                        </div>
                    )}
                    <div className="mt-5 d-flex flex-row align-items-center justify-content-center">
                        <button
                            type="button"
                            className="btn btn-light-primary font-weight-bold btn-sm"
                        >
                            Upgrade Plan
                        </button>
                    </div>
                </div>

            </div>
        </div>
    );
};
